import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelector } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
var Recaptcha = require('react-recaptcha');

export interface Props {
    tema: 'light' | 'dark';
    tipo: 'image' | 'audio';
    sitekey: string;
    onSuccess: (reset: () => void) => void;
    onExpired?: () => void;
}

export class KeaCaptcha extends React.PureComponent<Props> {
    public recaptchaInstance;

    private callback = () => {
        this.props.onSuccess(() => this.recaptchaInstance.reset());
    }

    private expiredCallback = () => {
        if (this.props.onExpired)
            this.props.onExpired();
    }

    sitekey = (x: Props) => x.sitekey;
    tipo = (x: Props) => x.tipo;
    tema = (x: Props) => x.tema;

    render() {
        const sitekey = this.sitekey(this.props);
        const tipo = this.tipo(this.props);
        const tema = this.tema(this.props);
        return (
            <div>
                <Recaptcha
                    ref={e => this.recaptchaInstance = e}
                    sitekey={sitekey}
                    hl="es"
                    theme={tema}
                    type={tipo}
                    verifyCallback={this.callback}
                    expiredCallback={this.expiredCallback}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./app/features/componentes/keacaptcha.tsx